import { useEffect, useState } from "react";

// Login and error pages never mount a Layout; the fallback keeps deferred work from starving there.
const FALLBACK_MS = 15_000;

let resolveFirstPaint: (() => void) | undefined;
let fallbackScheduled = false;
const firstPainted = new Promise<void>((resolve) => {
  resolveFirstPaint = resolve;
});

export function markFirstPaint(): void {
  requestAnimationFrame(() => resolveFirstPaint?.());
}

export function whenFirstPainted(): Promise<void> {
  if (!fallbackScheduled) {
    fallbackScheduled = true;
    setTimeout(() => resolveFirstPaint?.(), FALLBACK_MS);
  }
  return firstPainted;
}

export function useMarkFirstPaint(): void {
  useEffect(() => {
    markFirstPaint();
  }, []);
}

export function useFirstPainted(): boolean {
  const [painted, setPainted] = useState(false);
  useEffect(() => {
    let active = true;
    void whenFirstPainted().then(() => {
      if (active) setPainted(true);
    });
    return () => {
      active = false;
    };
  }, []);
  return painted;
}
